import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';

/**
 * A product's real photo, or — when it has none, or the URL fails to load —
 * an understated Fresh & Homely placeholder: pale green, a package mark and
 * "Image coming soon". Never a stand-in photo, never the browser's broken
 * image icon. Fills its parent; the parent sets the size and radius.
 *
 *   size="card"  placeholder with the caption (cards, detail gallery)
 *   size="thumb" mark only (small thumbnails)
 */
const ProductImage = ({ src, alt = '', size = 'card', className = '', imgClassName = '', loading = 'lazy' }) => {
  const [failed, setFailed] = useState(false);
  // A new URL gets a fresh attempt.
  useEffect(() => setFailed(false), [src]);

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={alt}
        loading={loading}
        onError={() => setFailed(true)}
        className={`w-full h-full object-cover ${imgClassName}`}
      />
    );
  }

  return (
    <span
      className={`w-full h-full flex flex-col items-center justify-center gap-1.5 pt-6 bg-[radial-gradient(circle_at_50%_40%,#F3FAF0_0%,#E9F4E6_100%)] text-emerald-700/55 ${className}`}
      data-testid="product-image-fallback"
      role={alt ? 'img' : undefined}
      aria-label={alt ? `${alt} — image coming soon` : undefined}
    >
      <Package size={size === 'thumb' ? 16 : 30} strokeWidth={1.5} aria-hidden="true" />
      {size === 'card' && (
        <span className="text-[11px] font-semibold tracking-wide text-emerald-800/55" aria-hidden="true">
          Image coming soon
        </span>
      )}
    </span>
  );
};

export default ProductImage;
